import { concat } from 'lodash';

import RouterBase from './base';
import RouterHome from './home';
import RouterPersons from './persons';
import RouterPrograms from './programs';
// import RouterPublic from './public';
import RouterSettings from './settings';
import RouterStuffToEat from './stuff-to-eat';
import RouterWorkspace from './workspace';

export default concat(
  RouterPersons,
  RouterPrograms,
  // RouterPublic,
  RouterSettings,
  RouterWorkspace,
  RouterStuffToEat,
  RouterBase,
  RouterHome,
);



// WEBPACK FOOTER //
// ./src/router/professional/index.js